import { FC } from 'react';
import { Typography } from 'antd';
import { useDrag } from 'react-dnd';
import styled from 'styled-components';
import { themeConfig, useThemeContext } from '@/shared/theme';
import { ComponentItemType, EventTypes } from '@/shared/types';
import { trigger } from '@/shared/utils';

const { Text } = Typography;

export const EditComponentItem: FC<ComponentItemType> = ({
  id,
  icon,
  title,
}) => {
  const { theme } = useThemeContext();

  const [{ isDragging }, drag] = useDrag(() => ({
    type: 'componentItem',
    item: { id, icon, title },
    options: { dropEffect: 'copy' },
    previewOptions: { captureDraggingState: true },
    collect: (monitor: any) => ({
      isDragging: !!monitor.isDragging(),
    }),
  }));

  return (
    <div
      data-testid={`component-${id}`}
      ref={drag}
      onClick={() =>
        trigger(EventTypes.COMPONENT_ADDED_TO_CANVAS, { id })
      }
      style={{
        borderRadius: 8,
        background: 'transparent',
        transform: 'translate(0, 0)',
        opacity: isDragging ? 0.5 : 1,
      }}
    >
      <ComponentItemWrapper
        $borderHoverColor={themeConfig[theme].colors.layoutOverlayContentBg}
        style={{
          background: themeConfig[theme].colors.contentBg,
          color: themeConfig[theme].colors.layoutOverlayContentBg,
          borderColor: themeConfig[theme].colors.contentBgSecondary,
        }}
      >
        {icon}
        <Text style={{ color: themeConfig[theme].colors.text, fontSize: 13 }}>
          {title}
        </Text>
      </ComponentItemWrapper>
    </div>
  );
};

const ComponentItemWrapper = styled.div<{ $borderHoverColor: string }>`
  height: 80px;
  width: 80px;
  border-radius: 8px;
  justify-content: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 10px;
  cursor: pointer;
  user-select: none;
  border: 1px solid;
  transition: border-color 0.2s ease-in-out;
  &:hover {
    border-color: ${({ $borderHoverColor }) => $borderHoverColor} !important;
  }
`;
